import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import Table from "@amzn/meridian/table";
import TableRow from "@amzn/meridian/table/table-row";
import TableCell from "@amzn/meridian/table/table-cell";
import {connect} from "react-redux";
import Link from "@amzn/meridian/link";
import {convertToString, getAliasFromLoginId, makeNumberTwoDigit} from "../../Utility";
import {FormattedMessage} from "react-intl";
import {getDocumentURL} from "../../handler/ParentDataHandler";
import {getLocale} from "../../handler/LocaleHandler";
import Column from "@amzn/meridian/column";
import RefreshTimer from "../RefreshTimer";

class AssociateTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sortColumn: "name",
            sortDirection: "ascending",
            baseURL: ""
        }
    }

    componentDidMount() {

        getDocumentURL().then(value => {
            this.setState(  {baseURL: value})
        });
    }

    render() {
        const {associatesList, selectedStatuses, selectedAisle, selectedClusters} = this.props;
        const onSort = (sortDetails) => {
            this.setState({
                sortColumn: sortDetails.sortColumn,
                sortDirection: sortDetails.sortDirection
            })
        }

        const filteredAssociatesList = associatesList ? associatesList.filter(function (associate) {
            const doesStatusMatch = !selectedStatuses.length || selectedStatuses.includes(associate.active);
            const doesClusterMatch = !selectedClusters.length || selectedClusters.includes(associate.cluster);
            const doesAisleMatch = !selectedAisle || selectedAisle === associate.location;
            return doesAisleMatch && doesClusterMatch && doesStatusMatch;
        }) : [];

        filteredAssociatesList && filteredAssociatesList.sort((a, b) => {

            const fieldA = a[this.state.sortColumn];
            const fieldB = b[this.state.sortColumn];

            if (this.state.sortDirection === "ascending") {
                return convertToString(fieldA)
                    .localeCompare(convertToString(fieldB), getLocale(), {numeric: true});
            } else {
                return convertToString(fieldB)
                    .localeCompare(convertToString(fieldA), getLocale(), {numeric: true});
            }
        })

        const getAssociateLink = (loginId) => {

            const searchURL = new URL(this.state.baseURL.replace('associatesort', 'search'));

            const startDate = new Date();
            startDate.setHours(0,0,0,0);

            const endDate = new Date();
            endDate.setDate(startDate.getDate() +1);
            endDate.setHours(0,0,0,0);

            const optionsObj = {
                "type": "ASSOCIATE",
                "startDate": startDate.getTime(),
                "endDate": endDate.getTime(),
            }

            const shareableLink = "/detailPage/" + loginId + '/' + JSON.stringify(optionsObj);
            searchURL.searchParams.set("shareableLink", shareableLink);

            return searchURL.href;
        };

        const renderAlias = (loginId) => {

            const alias = getAliasFromLoginId(loginId);
            try {
                return <Link href={getAssociateLink(loginId)} type="secondary" target="_blank">
                    {alias}
                </Link>
            } catch (e) {
                return alias;
            }
        }

        return (
            <Column>
                <RefreshTimer deps={[associatesList]} />
                <div style={{ overflowX: "auto", width: "100%" }}>
                    <Table headerRows={1} showDividers={false} showStripes={false} spacing="small"
                               fixHeaderRows={true}
                               fixHeaderRowsFullWidth={true}
                               headerColumns={1}
                               stickyHeaderColumn={true}
                               sortColumn={this.state.sortColumn}
                               sortDirection={this.state.sortDirection}
                               onSort={onSort} data-cy={"associateTable"}>
                            <TableRow>
                                <TableCell sortColumn="name">
                                    <FormattedMessage id="associate.associate" defaultMessage="Associate"/>
                                </TableCell>
                                <TableCell sortColumn="pph" alignmentHorizontal="right">
                                    <FormattedMessage id="associate.pph" defaultMessage="PPH"/>
                                </TableCell>
                                <TableCell sortColumn="minutesWorked" alignmentHorizontal="right">
                                    <FormattedMessage id="associate.hours" defaultMessage="Hours"/>
                                </TableCell>
                                <TableCell sortColumn="stowedPackages" alignmentHorizontal="right">
                                    <FormattedMessage id="associate.total_pkgs" defaultMessage="Total Pkgs"/>
                                </TableCell>
                                <TableCell sortColumn="fsaf" alignmentHorizontal="right">
                                    <FormattedMessage id="associate.fsaf" defaultMessage="FSAF"/>
                                </TableCell>
                                <TableCell sortColumn="fsafDpmo" alignmentHorizontal="right">
                                    <FormattedMessage id="associate.fsaf_dpmo" defaultMessage="FSAF DPMO"/>
                                </TableCell>
                                <TableCell sortColumn="active">
                                    <FormattedMessage id="associate.active" defaultMessage="Active"/>
                                </TableCell>
                                <TableCell sortColumn="location">
                                    <FormattedMessage id="associate.lastLocation" defaultMessage="Last Location"/>
                                </TableCell>
                            </TableRow>
                            {
                                filteredAssociatesList && filteredAssociatesList.map(associate => (
                                    <TableRow key={associate.alias} data-cy={"associateDataRow"}>
                                        <TableCell>
                                            {renderAlias(associate.alias)}
                                        </TableCell>
                                        <TableCell alignmentHorizontal="right">{associate.pph}</TableCell>
                                        <TableCell
                                            alignmentHorizontal="right">{getFormattedHoursFromMinutes(associate.minutesWorked)}</TableCell>
                                        <TableCell alignmentHorizontal="right">{associate.stowedPackages+associate.stowedBufferedPackages}</TableCell>
                                        <TableCell alignmentHorizontal="right">{associate.fsaf}</TableCell>
                                        <TableCell alignmentHorizontal="right">{associate.fsafDpmo}</TableCell>
                                        <TableCell>{associate.active}</TableCell>
                                        <TableCell>{associate.location}</TableCell>
                                    </TableRow>
                                ))
                            }
                        </Table>
                </div>
            </Column>
        )

        function getFormattedHoursFromMinutes(minutesWorked) {
            const hoursWorked = makeNumberTwoDigit(Math.floor(minutesWorked / 60));
            const remainingMinutes = makeNumberTwoDigit(minutesWorked % 60);
            return hoursWorked + ':' + remainingMinutes;
        }
    }
}

const mapStateToProps = state => ({
    associatesList: state.associateReducer.associatesList,
    selectedStatuses: state.optionsReducer.options.associateStatuses,
    selectedClusters: state.optionsReducer.options.clusters,
    selectedAisle: state.optionsReducer.options.aisle,
});
export default withRouter(connect(mapStateToProps)(AssociateTable));


// WEBPACK FOOTER //
// ./src/components/associate/AssociateTable.js